export default __webpack_public_path__ + "static/media/fruteira.280347a8.png";